<!-- Desktop view, with top navigation bar -->
@if (!isMobileView && navbarType === 'top') {
  <div class="d-sm-block navbar-height"></div>
  <div class="d-sm-block navbar navbar-desktop">
    <mat-toolbar color="primary" class="upper-nav">
      <mat-toolbar class="desktop-width-limiter margin-top navPrimary">
        <div class="navBrand">
          <img
            [title]="'general.home_navigation' | translate"
            class="nav-logo"
            height="62"
            [alt]="'app_title' | translate | titlecase"
            src="./assets/images/logo.svg"
            routerLink=""
            />
            <img
              [src]="getLogo()"
              [title]="'general.home_navigation' | translate"
              class="nav-logo-name"
              [ngClass]="{ 'blue-logo-filter': applyLogoFilter }"
              [alt]="'app_title' | translate | titlecase"
              routerLink=""
              />
            </div>
            <div class="navUser">
              <!-- Login Button -->
              @if (!isLoggedIn()) {
                <button
                  mat-flat-button
                  class="login-button"
                  [title]="'menu.login' | translate"
                  (click)="login()"
                  >
                  {{ "menu.login" | translate }}
                </button>
              }
              <!-- Profile Button/Icon -->
              @if (isLoggedIn()) {
                <img
                  [src]="getProfileImage()"
            [ngClass]="{
              'supporter': isSupporter()
            }"
                  onerror="this.onerror=null;this.src='/assets/images/user.png';"
                  height="16"
                  width="16"
                  [alt]="'navbar.nb3' | translate | titlecase"
                  [title]="'menu.profile' | translate"
                  (click)="navigateToProfile()"
                  />
              }
            </div>
          </mat-toolbar>
        </mat-toolbar>
      </div>
    }

    <!-- Menu Left Sidenav -->
    @if (!isMobileView && navbarType === 'left-side') {
      <div class="menu-items">
        @for (item of filterItemsWithUserRoles(); track item) {
          <!-- Buttons per available route -->
          <button
            mat-flat-button
            #tooltip="matTooltip"
            [matTooltip]="item.title | translate"
            matTooltipPosition="right"
            matTooltipClass="menu-tooltip"
            [aria-tooltip]="item.title | translate"
            [routerLink]="item.routerLink"
            [ngClass]="{ active: item === activeItem }"
            class="nav-singleItem"
            >
            <!-- Selection Line -->
            <div class="selectedLine"></div>
            @if (item.routerLink !== '/112' && item.routerLink !== '/ranglijst') {
              <mat-icon
                >{{ item.icon }}</mat-icon
                >
              }
              <!-- 112 Icon -->
              @if (
                item.routerLink === '/112' && activeItem?.routerLink !== '/112'
                ) {
                <img
                  src="/assets/images/alarm-light-outline-white.png"
                  alt="Alarm Light Outline"
                  />
              }
              @if (
                item.routerLink === '/112' && activeItem?.routerLink === '/112'
                ) {
                <img
                  src="/assets/images/alarm-light-outline-orange.png"
                  alt="Alarm Light Outline"
                  />
              }
              <!-- Sebbies -->
              @if (
                item.routerLink === '/ranglijst' &&
                activeItem?.routerLink !== '/ranglijst'
                ) {
                <img
                  src="/assets/images/sebbies/ranking-star-solid_white.svg"
                  alt="Sebbies"
                  class="sebbies"
                  />
              }
              @if (
                item.routerLink === '/ranglijst' &&
                activeItem?.routerLink === '/ranglijst'
                ) {
                <img
                  src="/assets/images/sebbies/ranking-star-solid.svg"
                  alt="Sebbies"
                  class="sebbies"
                  />
              }
            </button>
          }
          @for (item of getItemsForRole(); track item) {
            <!-- Role specific routes -->
            <button
              mat-flat-button
              #tooltip="matTooltip"
              [matTooltip]="item.title | translate"
              matTooltipPosition="right"
              matTooltipClass="menu-tooltip"
              [aria-tooltip]="item.title | translate"
              [id]="item.icon"
              class="nav-singleItem"
              [ngClass]="{ active: item === activeItem }"
              [routerLink]="item.routerLink"
              [title]="item.title | translate"
              >
              <!-- Selection Line -->
              <div class="selectedLine"></div>
              @if (
                item.icon &&
                (item.icon !== 'account_circle' || !isLoggedIn()) &&
                item.icon !== 'camera_alt'
                ) {
                <mat-icon
                  color="primary"
                  class="icon"
                  >{{ item.icon }}</mat-icon
                  >
                }
              </button>
            }
          </div>
        }

        <!-- Mobile navigation bar at the bottom -->
        @if (isMobileView && navbarType === 'mobile') {
          <div class="mobile-bottom-bar">
            <div class="bottom-bar-first-half" (click)="mobileCreateClick()">
              <img src="/assets/images/Logo_halve_ring.png" alt="StreApp plaatsen" />
            </div>
            <div class="bottom-bar-second-half">
              <mat-icon
                [title]="'menu.live' | translate"
                [routerLink]="'/'"
                class="icon-update"
                [class.active]="activeItem?.routerLink === '/'"
                >home</mat-icon
                >
                <mat-icon
                  [title]="'menu.kaart' | translate"
                  (click)="mobileMapClick()"
                  class="icon-map"
                  [class.active]="activeItem?.routerLink === '/kaart'"
                  >map</mat-icon
                  >
                  <mat-icon
                    [title]="'menu.lokaal' | translate"
                    (click)="mobileLocalClick()"
                    class="icon-local"
                    [class.active]="activeItem?.routerLink === '/lokaal'"
                    >my_location</mat-icon
                    >
                    <span
                      [title]="'menu.p2000' | translate"
                      [routerLink]="'/112'"
                      class="icon-alert"
                      >
                      @if (activeItem?.routerLink !== '/112') {
                        <img
                          src="/assets/images/alarm-light-outline-white.png"
                          alt="Alarm Light Outline"
                          />
                      }
                      @if (activeItem?.routerLink === '/112') {
                        <img
                          src="/assets/images/alarm-light-outline-orange.png"
                          alt="Alarm Light Outline"
                          />
                      }
                    </span>
                    <mat-icon
                      [title]="'menu.menu' | translate"
                      class="icon-menu"
                      [class.active]="sidenav.opened"
                      (click)="sidenav.toggle()"
                      >more_vert</mat-icon
                      >
                    </div>
                  </div>
                  <!-- Menu SideNav for mobile-->
                  @if (sidenav.opened) {
                    <div
                      class="sidenav-backdrop"
                      (click)="sidenav.toggle()"
                    ></div>
                  }
                  <mat-sidenav
                    #sidenav
                    (click)="sidenav.toggle()"
                    class="nav-mobile"
                    [autoFocus]="false"
                    [position]="'end'"
                    >
                    <div class="sidenav-header mat-elevation-z4">
                      <span class="header-title">{{
                        "menu.menu_items.title" | translate
                      }}</span>
                      <button
                        class="close-ref"
                        mat-icon-button
                        (click)="sidenav.toggle()"
                        [title]="'general.close' | translate | titlecase"
                        >
                        <mat-icon (click)="sidenav.toggle()">clear</mat-icon>
                      </button>
                    </div>
                    <!-- Links Depending on Role -->
                    <span>
                      <!-- Profile Button -->
                      @if (isLoggedIn()) {
                        <button
                          mat-flat-button
                          class="nav-singleItem"
                          [title]="'menu.menu_items.profile' | translate"
                          (click)="navigateToProfile()"
                          >
                          <img
                            class="profile-image-nav"
                            [src]="getProfileImage()"
                            onerror="this.onerror=null;this.src='/assets/images/user.png';"
                            height="24"
                            width="24"
                            [alt]="'navbar.nb3' | translate | titlecase"
                            />
                            <span>{{ "menu.menu_items.profile" | translate }}</span>
                          </button>
                        }
                        <!-- Streappers Button -->
                        <button
                          mat-flat-button
                          routerLink="/streappers"
                          class="nav-singleItem"
                          [title]="'menu.menu_items.streappers' | translate"
                          >
                          <img
                            class="profile-image-nav"
                            src="/assets/images/logo_reporter_los.svg"
                            onerror="this.onerror=null;this.src='/assets/images/user.png';"
                            height="24"
                            width="24"
                            [alt]="'navbar.nb3' | translate | titlecase"
                            />
                            <span>{{ "menu.menu_items.streappers" | translate }}</span>
                          </button>
                          <!-- Sebbies Button -->
                          <button
                            mat-flat-button
                            routerLink="/ranglijst"
                            class="nav-singleItem"
                            [title]="'menu.menu_items.sebbies' | translate"
                            >
                            <img
                              class="sebbies-mobile"
                              src="/assets/images/sebbies/ranking-star-solid_white.svg"
                              onerror="this.onerror=null;"
                              height="24"
                              width="24"
                              [alt]="'navbar.nb3' | translate | titlecase"
                              />
                              <span>{{ "menu.menu_items.sebbies" | translate }}</span>
                            </button>
                            <!-- Info Button -->
                            <button
                              mat-flat-button
                              routerLink="/over-ons"
                              class="nav-singleItem"
                              [title]="'menu.menu_items.info' | translate"
                              >
                              <mat-icon color="primary" class="mobile-icon"> info </mat-icon>
                              <span>{{ "menu.menu_items.info" | translate }}</span>
                            </button>
                            @for (item of getItemsForRole(); track item) {
                              <button
                                [id]="item.icon"
                                class="nav-singleItem"
                                mat-flat-button
                                [routerLink]="item.routerLink"
                                [title]="'item.title' | translate"
                                >
                                @if (
                                  item.icon &&
                                  (item.icon !== 'account_circle' || !isLoggedIn()) &&
                                  item.icon !== 'camera_alt'
                                  ) {
                                  <mat-icon
                                    color="primary"
                                    class="mobile-icon"
                                    >{{ item.icon }}</mat-icon
                                    >
                                }
                                <span>{{ item.title | translate }}</span>
                              </button>
                            }
                          </span>
                          @if (isLoggedIn()) {
                            <span>
                              <button
                                id="navSideLogout"
                                class="nav-singleItem"
                                mat-flat-button
                                (click)="signout()"
                                >
                                <mat-icon color="primary" class="mobile-icon">exit_to_app</mat-icon>
                                <span>{{ "menu.signout" | translate }}</span>
                              </button>
                            </span>
                          }
                          @if (!isLoggedIn()) {
                            <span>
                              <button
                                id="navSideLogin"
                                class="nav-singleItem"
                                mat-flat-button
                                (click)="login()"
                                >
                                <mat-icon color="primary" class="mobile-icon">login</mat-icon>
                                <span>{{ "menu.login" | translate }}</span>
                              </button>
                            </span>
                          }
                          <hr />
                          <span class="socials">
                            <a
                              href="https://x.com/streapp_com"
                              target="_blank"
                              class="nav-singleItem"
                              >
                              <img
                                width="24"
                                height="24"
                                src="/assets/images/socials/X_logo_2023_original.svg"
                                />
                              </a>
                              <a
                                href="http://instagram.com/streapp"
                                target="_blank"
                                class="nav-singleItem"
                                >
                                <img
                                  width="24"
                                  height="24"
                                  src="/assets/images/socials/Instagram_color.png"
                                  />
                                </a>
                                <a
                                  href="https://www.facebook.com/profile.php?id=100089259057883"
                                  target="_blank"
                                  class="nav-singleItem"
                                  >
                                  <img
                                    width="24"
                                    height="24"
                                    src="/assets/images/socials/Facebook_color.png"
                                    />
                                  </a>
                                </span>
                              </mat-sidenav>
                            }
